/**
 * DisplayCurrencySwitcher.js
 *
 * Pill-style toggle group used at the top of the Budget tab (and any
 * other dashboard that re-expresses PLN values in a user-chosen
 * currency).  Persists choice via the ``useDisplayCurrency`` hook.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDisplayCurrency } from '../hooks/useDisplayCurrency';
import { Banknote } from 'lucide-react';

export default function DisplayCurrencySwitcher({ compact = false, className = '' }) {
  const { t } = useTranslation();
  const { currency, setCurrency, supported } = useDisplayCurrency();
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="display-currency-switcher">
      {!compact && (
        <span className="text-xs text-slate-500 flex items-center gap-1">
          <Banknote className="w-3.5 h-3.5" /> {t('budget.displayIn')}
        </span>
      )}
      <div className="inline-flex rounded-md border bg-white overflow-hidden shadow-sm">
        {supported.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setCurrency(c)}
            className={
              'px-2.5 py-1 text-xs font-medium transition-colors border-r last:border-r-0 ' +
              (currency === c
                ? 'bg-blue-600 text-white'
                : 'bg-white text-slate-600 hover:bg-slate-50')
            }
            data-testid={`display-currency-${c}`}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  );
}
